import TableList from "@components/templates/tablelist";
import { HttpGetSupplierUser } from '@/service/ucadm';
export default {
    props: ['params'],
    mixins: [TableList],
    data () {
        return {
            isMixin: true,
            Searchs: {
                show: false,
                // style: "border:none;",
                // labelWidth: 'auto',
                // align: "left",
            },
        }
    },
    computed: {
        columns () {
            return [{
                title: '姓名',
                key: 'name'
            }, {
                title: '邮箱',
                key: 'email'
            }, {
                title: '最后登录时间',
                key: 'lastLoginTime'
            }]
        },
    },
    created () {
        // console.log(this.$route)
        this.startUp = 1
    },
    methods: {
        ajaxRequest: HttpGetSupplierUser,
        interceptRequest(params) {
            params.id = this.params.id;
            // // params.search.EQ_status = 0
            // params.search.EQ_enable = 1
            // // delete params.rows
            // // delete params.page
            return params
        },
    },
}